import './src/styles/bootstrap.min.css';
import './src/styles/blueprint.scss';
import './src/styles/global.scss';

require('typeface-open-sans');
require('typeface-playfair-display');
